import script from "./changeLang.vue?vue&type=script&lang=js"
export * from "./changeLang.vue?vue&type=script&lang=js"

export default script